import React, { useState, useEffect } from 'react'
import ReduceBigNumbers from './ReduceBigNumbers'

function Controls({ roomData, user, socket }) {
    const [ player, setPlayer ] = useState( null )
    const [ controlsStructure, setControlsStructure ] = useState( null )
    const [ controls, setControls ] = useState( [] )
    const [ scaleRange, setScaleRange ] = useState( null )
    const [ sumForBetOrRaise, setSumForBetOrRaise ] = useState( null )
    const [ sumForBetOrRaiseButton, setSumForBetOrRaiseButton ] = useState( null )
    const [ sumForScaleInput, setSumForScaleInput ] = useState( sumForBetOrRaiseButton )
    const [ scale, setScale ] = useState( <div></div> )
    const [ moreThenOnePlayerIsAtTheTable, setMoreThenOnePlayerIsAtTheTable ] = useState( false )
    const handleFocus = ( event ) => event.target.select()


    useEffect( () =>{

        findCurrentPlayer()
        checkIfMoreThenOnePlayerIsAtTheTable()

    }, [ roomData ])


    useEffect( ()=>{
        if( scaleRange ) setDefaultSumForScale( scaleRange )
        if( player ){
            if( !controlsStructure ) setControlsStructure( player.controls )
            if( !scaleRange ) setRangeForScale( player.controls )
            if( sumForBetOrRaise ) setSumForBetOrRaiseButton ( Number( sumForBetOrRaise ) + Number( player.currentBet ) )
            if( !sumForScaleInput ) setSumForScaleInput( Number( sumForBetOrRaise ) + Number( player.currentBet ) )
        }else{
            if( controls.length ) setControls( [] )
            if( controlsStructure ) setControlsStructure( null )
            if( scaleRange ) setScaleRange( null )
            if( sumForBetOrRaise ) setSumForBetOrRaise( null )
            if( sumForScaleInput ) setSumForScaleInput( null )
        }

    }, [ player, scaleRange, sumForBetOrRaise, sumForScaleInput ])


    useEffect( ()=>{
        try{
            let cntrls = []
            let scl = null
            let buttonText = ( text )=>{
                if( Number( sumForBetOrRaise ) < Number( player.buyIn ) ) return text + ' ' + ReduceBigNumbers( sumForBetOrRaiseButton )
                if( Number( sumForBetOrRaise ) === Number( player.buyIn ) ) return 'All In'
            }
            let betRaiseAllIn = ()=>{
                if( controlsStructure && controlsStructure.bet && controlsStructure.bet.enable && sumForBetOrRaiseButton ){
                    return(
                        <button key = '3' onClick={()=> handleTurn ( Number( sumForBetOrRaise ) === Number( player.buyIn ) ? 'allIn' : 'bet', sumForBetOrRaise, user._id )} className = 'gameControls gameControls_Active gameControls_BetRaiseAllIn' ><p>{ buttonText( 'Bet' )}</p></button> 
                    )
                }
                if( controlsStructure && controlsStructure.raise && controlsStructure.raise.enable && sumForBetOrRaiseButton ){
                    return(
                        <button key = '4'  onClick={()=> handleTurn ( Number( sumForBetOrRaise ) === Number( player.buyIn ) ? 'allIn' : 'raise', sumForBetOrRaise, user._id )} className = 'gameControls gameControls_Active gameControls_BetRaiseAllIn' ><p>{ buttonText( 'Raise to' ) }</p></button> 
                    )
                }
                
                if( controlsStructure && controlsStructure.allIn && controlsStructure.allIn.enable ){
                    cntrls.push(
                        <button ckey = '5' onClick={()=> handleTurn ( 'allIn', controlsStructure.allIn.sum, user._id )} className = 'gameControls gameControls_Active gameControls_BetRaiseAllIn' ><p>All In</p></button> 
                    )
                }
            }
    
            if( controlsStructure && controlsStructure.fold && controlsStructure.fold.enable ){
                cntrls.push(
                    <button key = '0' onClick={()=> handleTurn ( 'fold', null, user._id )} className = 'gameControls gameControls_Active gameControls_Fold' ><p>Fold</p></button> 
                )
            }

            if( controlsStructure && controlsStructure.check && controlsStructure.check.enable ){
                cntrls.push(
                    <button key = '1' onClick={()=> handleTurn ( 'check', null, user._id )} className = 'gameControls gameControls_Active gameControls_Check' ><p>Check</p></button> 
                )
            }
    
            if( controlsStructure && controlsStructure.call && controlsStructure.call.enable ){
                cntrls.push(
                    <button key = '2' onClick={()=> handleTurn ( 'call', controlsStructure.call.sum, user._id )} className = 'gameControls gameControls_Active gameControls_Call' ><p>{ 'Call ' + ReduceBigNumbers( controlsStructure.call.sum ) || null }</p></button> 
                )
            }
    
            if( betRaiseAllIn() ){ cntrls.push( betRaiseAllIn() )}
    
            if( sumForBetOrRaiseButton && scaleRange && scaleRange.min && scaleRange.max &&  scaleRange.min < scaleRange.max ){
                scl = 
                <div className="raisePanel">
                    <div className='volumeRangeHolder'>
                        <div className="gradationHolder">
                            <div className="gradation" onClick={( e )=>{ scaleChangeSum( 'min', scaleRange.min, scaleRange.max ) }}>
                                <div className='sign'>Min</div>
                                {/* <div className='pin'></div> */}
                            </div>
                            <div className="gradation" onClick={( e )=>{ scaleChangeSum( '1/4', scaleRange.min, scaleRange.max ) }}>
                                <div className='sign' >1/4</div>
                                {/* <div className='pin'></div> */}
                            </div>
                            <div className="gradation" onClick={( e )=>{ scaleChangeSum( '1/2', scaleRange.min, scaleRange.max ) }}>
                                <div className='sign'>1/2</div>
                                {/* <div className='pin'></div> */}
                            </div>
                            <div className="gradation" onClick={( e )=>{ scaleChangeSum( '3/4', scaleRange.min, scaleRange.max ) }}>
                                <div className='sign'>3/4</div>
                                {/* <div className='pin'></div> */}
                            </div>
                            <div className="gradation" onClick={( e )=>{ scaleChangeSum( 'max', scaleRange.min, scaleRange.max ) }}>
                                <div className='sign'>Max</div>
                                {/* <div className='pin'></div> */}
                            </div>
                        </div>
                        <input className="volumeRange" type="range" id="volumeRange" name="volumeRange" min={ scaleRange.min } max={ scaleRange.max } step="1" value={ sumForBetOrRaise } onChange={ scaleOnChange }></input>
                    </div>
                    {/* <input className="volumeNumber" type="number" id="volumeNumber" name="volumeNumber" min={ 1 } max={ 100 } step="1" value={ sumForScaleInput } onChange={ sumForScaleInputChange } onFocus={ handleFocus }></input> */}
                </div>
            }else{
                if( controlsStructure && ( controlsStructure.bet && controlsStructure.bet.enable || controlsStructure.raise && controlsStructure.raise.enable ) ){
                    scl = 
                    <div className="raisePanel_placement"></div>
                }
            }
            setControls( cntrls )
            setScale( scl )
        }catch( e ){
            // console.log( e )
        }

    }, [ controlsStructure, sumForBetOrRaiseButton, sumForScaleInput ] )

    function findCurrentPlayer () {
        if( roomData && roomData.participants ){
            let p = null
            roomData.participants.map( ( participant )=>{
                if( user && user._id && participant.participant && participant.participant._id && participant.participant._id === user._id && participant.currentPlayer ){
                    p = participant
                }
            })
            setPlayer( p )
        }
    }

    function checkIfMoreThenOnePlayerIsAtTheTable () {
        let count = 0
        
        if( roomData && roomData.participants && roomData.participants.constructor === Array ){
            roomData.participants.map(( participant )=>{
                if( participant.participant && participant.status === 'player' ){
                    count += 1
                }
            })
            if( count > 1 ){
                setMoreThenOnePlayerIsAtTheTable( true )
            }else{
                setMoreThenOnePlayerIsAtTheTable( false ) 
            }
        }
    }

    function scaleChangeSum( part, min, max ){
        // console.log( Math.round(( max - min ) /2 ) + min )
        switch( part ){
            case 'min' : handleScaleChangeSum( min ) //setSumForBetOrRaise( min )
            break;
            case '1/4' : handleScaleChangeSum( Math.round(( max - min ) /4 ) + min )  //setSumForBetOrRaise( Math.round(( max - min ) /4 ) + min )
            break;
            case '1/2' : handleScaleChangeSum( Math.round(( max - min ) /2 ) + min )  //setSumForBetOrRaise( Math.round(( max - min ) /2 ) + min )
            break;
            case '3/4' : handleScaleChangeSum( Math.round(( max - min ) /4 *3 ) + min )  //setSumForBetOrRaise( Math.round(( max - min ) /4 *3 ) + min )
            break;
            case 'max' : handleScaleChangeSum( max )  //setSumForBetOrRaise( max )
        }
    }

    function handleScaleChangeSum ( sum ) {
        setSumForBetOrRaise( sum )
        setSumForScaleInput( sum )
    }

    function scaleOnChange( e ) {
        try{
            if( Number( e.target.value ) >= Number( scaleRange.min ) && Number( e.target.value ) <= Number( scaleRange.max ) ){
                setSumForBetOrRaise( Number( e.target.value ) )
                setSumForScaleInput( Number( e.target.value ) + player.currentBet )
            }
        }catch( e ){
            // console.log( e )
        }
    }

    function sumForScaleInputChange ( e ){
        // console.log( e.target.value )
        if( e.target.value ){
            setSumForScaleInput( Number( e.target.value ))
            if( Number( e.target.value ) > scaleRange.min && Number( e.target.value ) < scaleRange.max ){ setSumForBetOrRaise( Number( e.target.value ) - Number( player.currentBet ))}    
        }
    }

    function setRangeForScale ( controls ){
        let range = {
            min : 0,
            max : 0
        }
        //set min
        if( controls.bet && controls.bet.enable ){
            range.min = controls.bet.sum.min 
        }
        if( controls.raise && controls.raise.enable ){
            range.min = controls.raise.sum.min 
        }

        //set max
        if( controls.allIn && controls.allIn.enable ){
            range.max = controls.allIn.sum 
        }else{
            if( controls.bet && controls.bet.enable ){
                range.max = controls.bet.sum.max 
            }
            if( controls.raise && controls.raise.enable ){
                range.max = controls.raise.sum.max 
            }
        }
        setScaleRange( range )
    }

    function setDefaultSumForScale( scaleRange ){
        if( scaleRange && scaleRange.min && !sumForBetOrRaise ){
            setSumForScaleInput( Number( scaleRange.min ) + Number( player.currentBet ) )
            setSumForBetOrRaise( Number( scaleRange.min ) )
        }
    }

    function handleTurn ( action, sum, userId ) {
        socket.socket.emit('handleTurn', {
            turn : action,
            userId : userId,
            sum : sum,
        })
    }

    if( moreThenOnePlayerIsAtTheTable ){
        return(
            <div className='controlsWrapper'>
                <div className='controls'>{ controls }</div>
                { scale }
            </div>
        )
    }else{
        return null
    }
}

export default Controls